import { render, staticRenderFns } from "./SyncProducts.vue?vue&type=template&id=8d3612aa&"
import script from "./SyncProducts.vue?vue&type=script&lang=js&"
export * from "./SyncProducts.vue?vue&type=script&lang=js&"
import style0 from "./SyncProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports